import API from '/vercel/path0/theme-default/builtins/API/index.js';
import Badge from '/vercel/path0/theme-default/builtins/Badge/index.js';
import CodeGroup from '/vercel/path0/theme-default/builtins/CodeGroup/index.js';
import Container from '/vercel/path0/theme-default/builtins/Container/index.js';
import Previewer from '/vercel/path0/node_modules/dumi-theme-mobile/dist/builtins/Previewer/index.js';
import SourceCode from '/vercel/path0/theme-default/builtins/SourceCode/index.js';
import Table from '/vercel/path0/theme-default/builtins/Table/index.js';
import Tree from '/vercel/path0/theme-default/builtins/Tree/index.js';
import ThemeCases from '/vercel/path0/.dumi/theme/builtins/ThemeCases/index.tsx';
import WhoAreUsing from '/vercel/path0/.dumi/theme/builtins/WhoAreUsing/index.tsx';
import { DumiDemo } from 'dumi';
import { DumiDemoGrid } from 'dumi';
import { Link } from 'dumi';

import LoadingComponent from '@@/dumi/theme/loading';
import React, { Suspense } from 'react';
import { DumiPage, useTabMeta, useRouteMeta } from 'dumi';

function DumiMarkdownInner() {
  const { texts: $$contentTexts } = useRouteMeta();

  return <><div className="markdown"><h2 id="谁在使用"><a aria-hidden="true" tabIndex="-1" href="#谁在使用"><span className="icon icon-link" /></a>{"谁在使用"}</h2></div><WhoAreUsing /><div className="markdown"><h2 id="反馈与共建"><a aria-hidden="true" tabIndex="-1" href="#反馈与共建"><span className="icon icon-link" /></a>{"反馈与共建"}</h2><p>{$$contentTexts[0].value}<a href="https://github.com/umijs/dumi">{$$contentTexts[1].value}</a>{$$contentTexts[2].value}</p><div>{$$contentTexts[3].value}<img data-type="dingtalk" src="https://mdn.alipayobjects.com/huamei_i7qs1c/afts/img/A*T94jRZmW1fgAAAAAAAAAAAAADs-oAQ" width="300" /></div></div></>;
}

// export named function for fastRefresh
// ref: https://github.com/pmmmwh/react-refresh-webpack-plugin/blob/main/docs/TROUBLESHOOTING.md#edits-always-lead-to-full-reload
function DumiMarkdownContent() {
  // wrap suspense for catch async meta data
  return <DumiPage><Suspense fallback={<LoadingComponent />}><DumiMarkdownInner /></Suspense></DumiPage>;
}

export default DumiMarkdownContent;